<template>
    <header :class="{isIndex: $store.state.isIndexPage}">
        <TopAds></TopAds>
        <div class="headWrap">
            <div class="headTop">
                <div class="headTopBox">
                    <div class="headTopLeft">
                        <span>{{$t('message.hiGoods')}}</span>
                    </div>
                    <div class="headTopRight">
                        <ul id="headTopNav">
                            <li v-if="!isIntl && $isZh()" class="headWx">
                                <a href="/tools/AppDownload" target="_blank">
                                    <i class="iconfont icon-shouji headPhone"
                                       @mouseenter="headAppWrapIsShow = !headAppWrapIsShow"
                                       @mouseleave="headAppWrapIsShow = !headAppWrapIsShow"
                                    ></i>
                                </a>
                                <i class="iconfont icon-weixin"
                                   @mouseenter="headWxWrapIsShow = !headWxWrapIsShow"
                                   @mouseleave="headWxWrapIsShow = !headWxWrapIsShow"></i>
                                <transition name="fadeApp">
                                    <div v-show="headAppWrapIsShow" class="headAppWrap">
                                        <div class="headAppTriangle"></div>
                                        <div class="headAppBox">
                                            <img src="@/assets/img/tools/appDownload/appDownQrCode.png">
                                        </div>
                                    </div>
                                </transition>
                                <transition name="fadeWx">
                                    <div v-show="headWxWrapIsShow" class="headWxWrap">
                                        <div class="headWxTriangle"></div>
                                        <div class="headWxBox">
                                            <img src="~@/assets/img/header/wx_qrcode.jpg">
                                        </div>
                                    </div>
                                </transition>
                            </li>
                            <li v-if="!isIntl && $isZh()"
                                :class="{headSiteNav:true,siteNavActive:siteNavActive}"
                                @mouseenter="headSiteNavClick();$bigData(bigData,thirdParty,'网站导航'+pathname)"
                                @click="headSiteNavClick();$bigData(bigData,thirdParty,'网站导航'+pathname)"
                                @mouseleave="siteNavActive = false">
                                <a href="javascript:void(0);">
                                    <i class="iconfont icon-tab"></i>
                                    <span>{{$t('message.siteNav')}}</span>
                                </a>
                                <i class="iconfont icon-xiala1"></i>
                                <transition name="fadeLang">
                                    <div v-show="siteNavActive"
                                         class="siteNavWrap"
                                         @click.stop="">
                                        <div v-for="(item,index) in siteNavData" :key="index">
                                            <div v-if="!item.hidden" class="navBox">
                                                <div :class="`tit ${item.colorClass}`">
                                                    <a v-if="item.link"
                                                       :class="item.colorClass"
                                                       :href="item.link"
                                                       target="_blank"
                                                       @click="siteNavDataClick(item.title)">{{item.title}}</a>
                                                    <span v-else
                                                          :class="item.colorClass"
                                                          style="cursor: auto;">{{item.title}}</span>
                                                </div>
                                                <div v-for="(jtem,jndex) in item.children" :key="jndex">
                                                    <div v-if="!jtem.hidden" class="navItemWrap">
                                                        <p class="navItem">
                                                            <!-- 血拼&限时&活动订舱 弹窗 -->
                                                            <a v-if="[$t('message.shopping'), $t('message.activityBooking')].includes(jtem.title)"
                                                               :class="`itemSpan ${item.colorClass}`"
                                                               href="javascript:void(0)"
                                                               @click="$Alert({ msg: '敬请期待！'});">
                                                                <i :style="`font-size: ${jtem.fontSize}`"
                                                                   :class="`iconfont ${jtem.icon} ${item.colorClass}`"></i>
                                                                <span>{{jtem.title}}</span>
                                                            </a>
                                                            <a v-else
                                                               :class="`itemSpan ${item.colorClass}`"
                                                               :href="jtem.link"
                                                               target="_blank"
                                                               @click="siteNavDataClick(item.title)">
                                                                <i :style="`font-size: ${jtem.fontSize}`"
                                                                   :class="`iconfont ${jtem.icon} ${item.colorClass}`"></i>
                                                                <span>{{jtem.title}}</span>
                                                            </a>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </transition>
                            </li>
                            <template v-if="$route.fullPath !== '/personalCenter/operationCenter/cargoQuery/importBusiness/ImportLogin'">
                                <li v-show="!loginData.loginType" class="headLogin">
                                    <a  id="headLoginBtn"
                                        href="javascript:void(0);"
                                        @click="$showLogin();$bigData(bigData,thirdParty,'登录'+pathname)">
                                        <span>{{$t('message.signIn')}}</span>
                                    </a>
                                    <span style="margin: 0 4px;">/</span>
                                    <router-link    id="headRegisterBtn"
                                                    to="/Register"
                                                    @click="$bigData(bigData,thirdParty,'注册'+pathname)">
                                        <span>{{$t('message.createAccount')}}</span>
                                    </router-link>
                                </li>
                            </template>
                           
                            <li v-show="loginData.loginType"
                                class="headSignOut"
                                @click="signOutFn">
                                <a href="javascript:void(0);">
                                    <span>{{$t('message.signOut')}}</span>
                                </a>
                            </li>
                            <li v-show="loginData.loginType"
                                class="headUsername"
                                @click="$bigData(bigData,thirdParty,'用户名'+pathname)">
                                <router-link :to="$isZh() ? '/personalCenter/PersonalCenterMain':'/personalCenter/operationCenter/cargoQuery/importBusiness/ImportStation'">
                                    <i class="iconfont icon-icon"></i>
                                    <span>{{$t('message.personalCenter')}}</span>
                                </router-link>
                            </li>
                            <li v-if="false" class="headBusinessEnter">
                                <a href="javascript:void(0);">
                                    <i class="iconfont icon-shangdian"></i>
                                    <span>{{$t('message.merchantsSettled')}}</span>
                                </a>
                            </li>

                            <li v-if="!isIntl" class="headCustomerService">
                                <i class="iconfont icon-dianhua"></i>
                                <span>400-728-5256</span>
                            </li>
                            <template v-if="!isIntl">
                                <li v-if="$i18n.locale==='zhCHS'"
                                    class="headOnlineService"
                                    :class="{langClick:customerServiceIsShow}"
                                    @mouseenter="customerServiceIsShow = !customerServiceIsShow;$bigData(bigData,thirdParty,'小喵在线'+pathname)"
                                    @click="customerServiceIsShow = !customerServiceIsShow;$bigData(bigData,thirdParty,'小喵在线'+pathname)"
                                    @mouseleave="customerServiceIsShow = false">
                                    <i class="iconfont icon-kefu"></i>
                                    <span>{{$t('message.customerService')}}</span>
                                    <i class="iconfont icon-xiala1"></i>
                                    <transition name="fadeLang">
                                        <div v-show="customerServiceIsShow"
                                             class="headCustomerServiceWrap"
                                             @click.stop="">
                                            <div class="headCustomerServiceBox">
                                                <ul class="headCustomerServiceUl">
                                                    <li>
                                                        <a :href="customerServiceQQ"
                                                           target="_blank"
                                                           class="exportCustomerServiceQQ">
                                                            <i></i>
                                                            {{$t('message.exportCustomerService')}}
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a :href="importCustomerServiceQQ"
                                                           target="_blank"
                                                           class="importCustomerServiceQQ">
                                                            <i></i>
                                                            {{$t('message.importCustomerService')}}
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </transition>
                                </li>
                                <li v-else
                                    class="headOnlineService"
                                    @click="customerServiceEmail();$bigData(bigData,thirdParty,'小喵在线'+pathname)">
                                    <i class="iconfont icon-kefu"></i>
                                    <span>{{$t('message.customerService')}}</span>
                                </li>
                            </template>
                            
                            <li class="headLang"
                                :class="{langClick:langIsShow}"
                                @mouseenter="langIsShow = !langIsShow;$bigData(bigData,thirdParty,'语言切换'+pathname)"
                                @click="langIsShow = !langIsShow;$bigData(bigData,thirdParty,'语言切换'+pathname)"
                                @mouseleave="langIsShow = false">
                                <i class="iconfont icon-diqiu"></i>
                                <span>Language</span>
                                <i class="iconfont icon-xiala1"></i>
                                <transition name="fadeLang">
                                    <div v-show="langIsShow"
                                         class="headLangWrap"
                                         @click.stop="">
                                        <div class="headLangBox">
                                            <ul class="headLangUl">
                                                <li>
                                                    <a class="langChineseZH"
                                                       href="javascript:void(0);"
                                                       @click="modifyLanguage('zhCHS')">简体中文</a>
                                                </li>
                                                <li>
                                                    <a class="langEnglishUS"
                                                       href="javascript:void(0);"
                                                       @click="modifyLanguage('en')">English
                                                        (United
                                                        States)</a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </transition>
                            </li>
                            <li class="headCurrency"
                                :class="{currencyClick:currencyIsShow}"
                                @mouseenter="currencyIsShow = !currencyIsShow;$bigData(bigData,thirdParty,'币种切换'+pathname)"
                                @click="currencyIsShow = !currencyIsShow;$bigData(bigData,thirdParty,'币种切换'+pathname)"
                                @mouseleave="currencyIsShow = false">
                                <i class="iconfont icon-bizhong"></i>
                                <span>{{$currencyFull($getNowCurrency())}}</span>
                                <i class="iconfont icon-xiala1"></i>
                                <transition name="fadeLang">
                                    <div v-show="currencyIsShow"
                                         class="headCurrencyWrap"
                                         @click.stop="">
                                        <div class="headLangBox">
                                            <ul class="headLangUl">
                                                <li>
                                                    <a class="CNY"
                                                       href="javascript:void(0);"
                                                       @click="modifyCurrency('CNY')">{{$t('message.CNY')}}</a>
                                                </li>
                                                <li>
                                                    <a class="USD"
                                                       href="javascript:void(0);"
                                                       @click="modifyCurrency('USD')">{{$t('message.USD')}}</a>
                                                </li>
                                                <li>
                                                    <a class="EUR"
                                                       href="javascript:void(0);"
                                                       @click="modifyCurrency('EUR')">{{$t('message.EUR')}}</a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </transition>
                            </li>
                            <!-- <li v-if="loginData.loginType && !$overseasType && $getNowCurrency()==='CNY' && $i18n.locale==='zhCHS'"-->
                            <li v-if="false"
                                class="shoppingCart"
                                @click="$bigData(bigData,thirdParty,'购物车'+pathname)">
                                <a href="/product/productCart.aspx">
                                    <i class="iconfont icon-gouwuche1"></i>
                                    <span class="txt">{{$t('message.cart')}}</span>
                                    <span class="total">{{$store.state.shoppingCart}}</span>
                                </a>
                            </li>
                            <li v-if="!$store.state.isIndexPage"
                                class="headBackHomepage"
                                @click="$bigData(bigData,thirdParty,'回到首页'+pathname)">
                                <a :href="isIntl || !$isZh() ? ( $store.state.Login.loginData.userType === '11' ? '/personalCenter/operationCenter/cargoQuery/importBusiness/ImportBusinessMain' : '/ImportHome' )  : '/'">
                                    <span>{{$t('message.home')}}</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div v-if="isShowHeaderBot" class="headBot">
                <div class="headBotBox">
                    <div class="headBotLeft">
                        <a class="logoBox" :href="isIntl || !$isZh() ? ( $store.state.Login.loginData.userType === '11' ? '/personalCenter/operationCenter/cargoQuery/importBusiness/ImportBusinessMain' : '/ImportHome' )  : '/'">
                            <div class="headSjmLogo" @click="$bigData(bigData,thirdParty,'三脚猫Logo'+pathname)"></div>
                        </a>
                    </div>
                    <p v-if="$i18n.locale === 'en'" class="headLogoTit">SJM International Air Online Booking
                        Platform</p>
                    <p v-else class="headLogoTit">国&ensp;际&ensp;空&ensp;运&ensp;订&ensp;舱&ensp;平&ensp;台</p>
                    <div class="headLogoTitTips">
                        <span class="blue">百&ensp;&ensp;问&ensp;&ensp;不&ensp;&ensp;如&ensp;&ensp;一&ensp;&ensp;键&ensp;&ensp;</span>
                        <span class="blue">空&ensp;&ensp;运</span>
                        <span class="red">一&ensp;&ensp;网</span>
                        <span class="yellow">打&ensp;&ensp;尽</span>
                    </div>
                    <div class="headBotRight">
                        <ul class="headProperty">
                            <li v-if="$overseasType === false && $i18n.locale === 'zhCHS'">
                                <i class="iconfont icon-xiaoshifuwu"></i>
                                <br>
                                <span>{{$t('message.property4')}}</span>
                            </li>
                            <li>
                                <i class="iconfont icon-baoxian"></i>
                                <br>
                                <span>{{$t('message.property3')}}</span>
                            </li>
                            <li>
                                <i class="iconfont icon-qian"></i>
                                <br>
                                <span>{{$t('message.property2')}}</span>
                            </li>
                            <li>
                                <i class="iconfont icon-cangweizhenshiyouxiao"></i>
                                <br>
                                <span>{{$t('message.property1')}}</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </header>
</template>

<script>

    import TopAds from '@/components/TopAds.vue';

    export default {
        name: 'Header',
        components: {
            TopAds,
        },
        props: {
            // 是否显示头部下半部分
            isShowHeaderBot: {
                type: Boolean,
                default: true
            },
        },
        data() {
            return {
                // 是否显示微信
                headWxWrapIsShow: false,
                // 是否显示App
                headAppWrapIsShow: false,
                // 选中语言切换
                langIsShow: false,
                // 选中币种切换
                currencyIsShow: false,
                // bigData
                bigData: 'sjmNewHeader',
                // thirdParty
                thirdParty: '新头部',
                // 网站导航选中
                siteNavActive: false,
                // 网站邮箱选中
                emailActive: false,
                // 是否海外链接
                isIntl: location.origin.includes('https://intl.3j-mall.com'),
                // 选中客服切换
                customerServiceIsShow: false
            };
        },
        computed: {
            // 海外用户标志
            overseasType() {
                return this.$store.state.Login.loginData.overseasType;
            },
            // 网站导航数据
            siteNavData() {
                return [
                    {
                        title: this.$t('message.bookingChannel'),// 订舱通道
                        link: '',
                        colorClass: 'blueTit',
                        children: [{
                            title: this.$t('message.smartBooking'),// 智能订舱
                            link: '/product/SmartProducts',
                            icon: 'icon-xianshang',
                            fontSize: '20px',
                        }, {
                            title: this.$t('message.activityBooking'),// 活动订舱
                            link: '/calendar/newactivity.aspx',
                            icon: 'icon-icon-xiankuang',
                            fontSize: '18px',
                            hidden: this.overseasType,
                        }]
                    }, {
                        title: this.$t('message.focusActivity'),// 聚焦活动
                        link: '',
                        colorClass: 'redTit',
                        hidden: this.overseasType,
                        children: [{
                            title: this.$t('message.shopping'),// 血拼
                            link: '/calendar/newactivity.aspx',
                            icon: 'icon-pintuan',
                            fontSize: '22px',
                        }, {
                            title: this.$t('message.limitedTimeSale'),// 限时
                            link: '/calendar/newactivity.aspx',
                            icon: 'icon-xianshi',
                            fontSize: '17px',
                        }]
                    }, {
                        title: this.$t('message.catTool'),// 喵工具
                        link: '',
                        colorClass: 'purpleTit',
                        children: [{
                            title: this.$t('message.miscellaneousBillsList'),// 杂费清单
                            link: '/tools/MiscellaneousBillsList',
                            icon: 'icon-qingdan',
                            fontSize: '21px',
                        }, {
                            title: this.$t('message.deliveryInformation'),// 交货资料
                            link: '/tools/DeliveryInformation',
                            icon: 'icon-dianpu1',
                            fontSize: '16px',
                        }, {
                            title: this.$t('message.friendshipLinkText2'),// PVG货运站
                            link: 'http://222.73.210.139/pactl/bill_query.php',
                            icon: 'icon-huoyun',
                            fontSize: '20px',
                        }, {
                            title: this.$t('message.friendshipLinkText3'),// 跟踪查询
                            link: 'http://www.aircargotracking.net/aircargo-tracking.html',
                            icon: 'icon-renwuchaxun',
                            fontSize: '20px',
                        }, {
                            title: this.$t('message.HSCoding'),// HS编码
                            link: 'http://www.i5a6.com/hscode/',
                            icon: 'icon-dianchi',
                            fontSize: '18px',
                        }]
                    }, {
                        title: this.$t('message.importBusiness'),// 进口管理
                        link: '',
                        colorClass: 'orangeTit',
                        children: [{
                            title: this.$t('message.importBusiness2'),// 进口业务
                            link: '/personalCenter/operationCenter/cargoQuery/importBusiness/ActivationCodeLogin',
                            icon: 'icon-maoyijinchukoulingshoupifa',
                            fontSize: '18px',
                        }]
                    }
                ];
            },
            // 地址
            pathname() {
                return this.$route.path;
            },
            // 登录数据
            loginData() {
                return this.$store.state.Login.loginData;
            },
            // 客服QQ
            customerServiceQQ() {
                return this.$pcOrMobileQQ(this.$store.state.customerServiceQQ);
            },
            importCustomerServiceQQ() {
                return this.$pcOrMobileQQ(this.$store.state.importCustomerServiceQQ);
            },
            // 客服Email
            customerServiceEmail() {
                return () => {
                    this.$emailContactUs({
                        email: this.$store.state.importEmailCustomerServiceEmail
                    });
                };
            },
        },
        methods: {
            // 切换语言
            modifyLanguage(lang) {
                this.$setCookie('i18n', lang, 365);
                window.top.location.reload();
                // 切换到中文币种改为人民币
                // if (lang === 'zhCHS') {
                //    this.$setCookie('currency', 'CNY', 365);
                //    if (this.isIntl) {
                //        window.top.location.replace('/personalCenter/operationCenter/cargoQuery/importBusiness/ImportBusinessMain?type=0');
                //    } else {
                //        window.top.location.replace('/');
                //    }
                // } else {
                //    // 如果英文页面也是人民币，则改为美元
                //    if (this.$getNowCurrency() === 'CNY') {
                //        this.$setCookie('currency', 'USD', 365);
                //    }
                //    window.top.location.replace('/personalCenter/operationCenter/cargoQuery/importBusiness/ImportBusinessMain?type=0');
                // }
            },
            // 切换币种
            modifyCurrency(currency) {
                this.$setCookie('currency', currency, 365);
                window.top.location.reload();
                // 切换到人民币语言改为中文
                // if (currency === 'CNY') {
                //    this.$setCookie('i18n', 'zhCHS', 365);
                //    if (this.isIntl) {
                //        window.top.location.replace('/personalCenter/operationCenter/cargoQuery/importBusiness/ImportBusinessMain?type=0');
                //    } else {
                //        window.top.location.replace('/');
                //    }
                // } else {
                //    this.$setCookie('i18n', 'en', 365);
                //    window.top.location.replace('/personalCenter/operationCenter/cargoQuery/importBusiness/ImportBusinessMain?type=0');
                // }
            },
            // 点击网站导航
            headSiteNavClick() {
                this.siteNavActive = !this.siteNavActive;// 选中网站导航
            },
            // 网站导航 点击具体项
            siteNavDataClick(val) {
                // 大数据 头部导航-网站导航 点击具体项
                this.$bigData('siteNavDataClick', '头部网站导航', val);
            },
            // 退出
            async signOutFn() {
                await this.$bigData(this.bigData, this.thirdParty, '退出' + this.pathname);
                this.$logout();
            }
        }
    };
</script>

<style scoped>
    .fadeWx-enter-active,
    .fadeWx-leave-active {
        transition: opacity 0.25s;
    }

    .fadeWx-enter,
    .fadeWx-leave-to {
        opacity: 0;
    }

    .fadeApp-enter-active,
    .fadeApp-leave-active {
        transition: opacity 0.25s;
    }

    .fadeApp-enter,
    .fadeApp-leave-to {
        opacity: 0;
    }

    .fadeLang-enter-active,
    .fadeLang-leave-active {
        transition: opacity 0.25s;
    }

    .fadeLang-enter,
    .fadeLang-leave-to {
        opacity: 0;
    }

</style>
<style lang="scss" scoped>
    /* header.isIndex { */

    /*    .headLogoTit, */

    /*    .headProperty > li > i.iconfont, */

    /*    .headProperty > li > span { */

    /*        color: white !important; */

    /*    } */

    /* } */

    header .headWrap {
        position: relative;
        display: block;
        width: 100%;
        min-width: 1245px;

        /* background-color: white; */
    }

    header .headTop {
        position: relative;
        width: 100%;
        height: 35px;
        background-color: #dcdcdc;
    }

    header .headTopBox {
        width: 1245px;
        height: 100%;
        margin: 0 auto;
    }

    header .headTopLeft {
        position: absolute;
        height: 100%;
        font-size: 12px;
        line-height: 35px;
        color: #999;
    }

    header .headTopRight {
        float: right;
        height: 100%;
    }

    header .headTopRight > #headTopNav {
        display: flex;
        flex-direction: row-reverse;
        align-items: center;
        height: 100%;
    }

    header .headTopRight > #headTopNav > li {
        position: relative;
        display: flex;
        align-items: center;
        height: 100%;

        /* border-left: 1px solid rgba(89, 87, 87, 0.25); */
        padding: 0 10px;
        cursor: pointer;
        user-select: none;
    }

    header .headTopRight > #headTopNav > li::before {
        position: absolute;
        top: 10px;
        left: 0;
        width: 1px;
        height: 15px;
        content: '';
        background-color: rgba(89, 87, 87, 0.25);
    }

    header .headTopRight > #headTopNav > li > a {
        display: flex;
        align-items: center;
    }

    header .headTopRight > #headTopNav > li:last-child::before {
        content: '';
        background-color: transparent;
    }

    header .headTopRight > #headTopNav > li.headLang:hover > *,
    header .headTopRight > #headTopNav > li.headCurrency:hover > *,
    header .headTopRight > #headTopNav > li.headSiteNav:hover > i,
    header .headTopRight > #headTopNav > li.headSiteNav:hover > a > i,
    header .headTopRight > #headTopNav > li.headSiteNav:hover > a > span,
    header .headTopRight > #headTopNav > li.headOnlineService:hover > *,
    header .headTopRight > #headTopNav > li.headBusinessEnter:hover > a > *,
    header .headTopRight > #headTopNav > li #headLoginBtn:hover > span,
    header .headTopRight > #headTopNav > li #headRegisterBtn:hover > span,
    header .headTopRight > #headTopNav > li.headUsername:hover > a > i,
    header .headTopRight > #headTopNav > li.headUsername:hover > a > span,
    header .headTopRight > #headTopNav > li.headSignOut:hover > a > span,
    header .headTopRight > #headTopNav > li.headEmail:hover > i,
    header .headTopRight > #headTopNav > li.headEmail:hover > span,
    header .headTopRight > #headTopNav > li.headBackHomepage:hover > a > span,
    header .headTopRight > #headTopNav > li.shoppingCart:hover > a > span.txt {
        color: #009fe8;
    }

    header .headTopRight > #headTopNav > li.headCustomerService,
    header .headTopRight > #headTopNav > li.headCustomerService i,
    header .headTopRight > #headTopNav > li.headCustomerService span {
        cursor: default;
    }

    header .headTopRight > #headTopNav > li.shoppingCart > a > span.txt {
        margin: 0 4px;
    }

    header .headTopRight > #headTopNav > li span,
    header .headTopRight > #headTopNav > li i {
        position: relative;
        font-size: 12px;
        color: #595757;
        transition: 0.25s all;
    }

    header .headTopRight > #headTopNav > li.headEmail > i {
        font-size: 14px;
    }

    header .headTopRight > #headTopNav > li.headEmail .headEmailWrap {
        position: absolute;
        top: 35px;
        right: 0;
        z-index: 4;
        width: 340px;
        text-align: center;
        background-color: white;
        border: 1px solid #b8b8b8;

        &:hover a {
            color: #009fe8;
        }

        > a {
            position: relative;
            box-sizing: border-box;
            display: inline-block;
            width: 100%;
            height: 100%;
            padding: 10px 10px;
        }
    }

    header .headTopRight > #headTopNav > li .iconfont.icon-shouji {
        margin-right: 4px;
        font-size: 18px;
        animation: phone 0.8s linear infinite;
    }

    @keyframes phone {
        0% {
            color: #2577e3; /* 蓝色 */
            transform: rotate(0deg);
        }

        7% {
            transform: rotate(12deg);
        }

        21% {
            transform: rotate(-12deg);
        }

        28% {
            transform: rotate(0deg);
        }

        35% {
            transform: rotate(12deg);
        }

        49% {
            color: #595757; /* 灰色 */
            transform: rotate(-12deg);
        }

        56% {
            transform: rotate(0deg);
        }

        63% {
            transform: rotate(12deg);
        }

        77% {
            transform: rotate(-12deg);
        }

        84% {
            transform: rotate(0deg);
        }
    }

    header .headTopRight > #headTopNav > li .iconfont.icon-dianhua {
        margin-right: 4px;
        font-size: 16px;
    }

    header .headTopRight > #headTopNav > li .iconfont.icon-icon {
        margin-right: 4px;
        font-size: 15px;
    }

    header .headTopRight > #headTopNav > li .iconfont.icon-shouji:hover {
        color: #2577e3;
    }

    header .headTopRight > #headTopNav > li .iconfont.icon-weixin {
        font-size: 20px;
    }

    header .headTopRight > #headTopNav > li .iconfont.icon-weixin:hover {
        color: #00bc0c;
    }

    header .headTopRight > #headTopNav > li .iconfont.icon-shangdian {
        margin-right: 4px;
        font-size: 14px;
    }

    header .headTopRight > #headTopNav > li .iconfont.icon-youxiang {
        top: 1px;
        margin-right: 4px;
        font-size: 14px;
    }

    header .headTopRight > #headTopNav > li .iconfont.icon-tab {
        margin-right: 4px;
        font-size: 14px;
    }

    header .headTopRight > #headTopNav > li .iconfont.icon-shangdian + span {
        margin-left: 3px;
    }

    header .headTopRight > #headTopNav > li .iconfont.icon-kefu {
        margin-right: 4px;
        font-size: 18px;
    }

    header .headTopRight > #headTopNav > li .iconfont.icon-diqiu {
        font-size: 18px;
    }

    header .headTopRight > #headTopNav > li .iconfont.icon-diqiu + span {
        margin-left: 4px;
    }

    header .headTopRight > #headTopNav > li .iconfont.icon-bizhong {
        font-size: 18px;
    }

    header .headTopRight > #headTopNav > li .iconfont.icon-bizhong + span {
        margin-left: 4px;
    }

    header .headTopRight > #headTopNav > li .iconfont.icon-xiala1 {
        top: 3px;
        display: inline-block;
        font-size: 14px;
        transform-origin: center;
    }

    header .headTopRight > #headTopNav > li.headSiteNav.siteNavActive > i,
    header .headTopRight > #headTopNav > li.headSiteNav.siteNavActive > a > i,
    header .headTopRight > #headTopNav > li.headSiteNav.siteNavActive > a > span {
        color: #009fe8;
    }

    header .headTopRight > #headTopNav > li.headSiteNav.siteNavActive .icon-xiala1 {
        transform: rotate(180deg);
    }

    header .headTopRight > #headTopNav > li.headSiteNav .siteNavWrap {
        position: absolute;
        top: 35px;
        right: 0;
        z-index: 11;
        display: flex;
        justify-content: space-around;
        width: 800px;
        min-height: 100px;
        padding: 10px;
        cursor: auto;
        background-color: white;
        border: 1px solid #b8b8b8;
        border-radius: 1px;

        .navBox {
            width: 180px;
            margin-right: 10px;

            > .tit {
                margin-bottom: 18px;
                font-size: 16px;
                font-weight: bold;
                word-wrap: break-word;

                > span,
                > a {
                    padding: 2px 5px;
                    font-size: 16px;
                    font-weight: bold;
                }
            }

            .blueTit {
                &:not(.itemHover) {
                    color: #0071bc;
                }

                &:hover {
                    * {
                        color: #0071bc;
                    }

                    color: #0071bc;
                }
            }

            .redTit {
                &:not(.itemHover) {
                    color: #ed1c24;
                }

                &:hover {
                    * {
                        color: #ed1c24;
                    }

                    color: #ed1c24;
                }
            }

            .purpleTit {
                &:not(.itemHover) {
                    color: #93278f;
                }

                &:hover {
                    * {
                        color: #93278f;
                    }

                    color: #93278f;
                }
            }

            .orangeTit {
                &:not(.itemHover) {
                    color: #f7931e;
                }

                &:hover {
                    * {
                        color: #f7931e;
                    }

                    color: #f7931e;
                }
            }

            .navItemWrap {
                display: flex;
                flex-direction: column;

                .navItem {
                    display: flex;
                    align-items: center;
                    margin-bottom: 12px;
                    word-break: break-all;

                    > a {
                        display: flex;
                        align-items: center;
                        float: left;
                        padding: 2px 3px;
                        border-radius: 2px;
                        transition: all 0.25s;

                        span {
                            font-size: 14px;
                        }

                        i.iconfont {
                            width: 20px;
                            margin-right: 4px;
                        }
                    }
                }
            }

            &:last-child {
                margin-right: 0;
            }
        }
    }

    header .headTopRight > #headTopNav > li.headLang.langClick i,
    header .headTopRight > #headTopNav > li.headLang.langClick span {
        color: #009fe8;
    }

    header .headTopRight > #headTopNav > li.headLang.langClick .iconfont.icon-xiala1 {
        transform: rotate(180deg);
    }

    header .headTopRight > #headTopNav > li.headOnlineService.langClick i,
    header .headTopRight > #headTopNav > li.headOnlineService.langClick span {
      color: #009fe8;
    }

    header .headTopRight > #headTopNav > li.headOnlineService.langClick .iconfont.icon-xiala1 {
      transform: rotate(180deg);
    }

    header .headTopRight > #headTopNav > li.headCurrency.currencyClick i,
    header .headTopRight > #headTopNav > li.headCurrency.currencyClick span {
        color: #009fe8;
    }

    header .headTopRight > #headTopNav > li.headCurrency.currencyClick .iconfont.icon-xiala1 {
        transform: rotate(180deg);
    }

    header .headTopRight > #headTopNav > li .iconfont.icon-gouwuche1 {
        font-size: 17px;
        color: #d81e06;
    }

    header .headTopRight > #headTopNav > li .total {
        position: relative;
        top: -7px;
        display: inline-block;
        min-width: 8px;
        padding: 0 4px;
        color: white;
        text-align: center;
        background-color: #d81e06;
        border-radius: 15px;
    }

    header .headWxWrap {
        /* display: none; */
        position: absolute;
        top: 35px;
        right: 0;
        z-index: 5;
        width: 126px;
        height: 126px;
        background-color: white;
        border: 1px solid #b8b8b8;
        border-radius: 1px;

        /* box-shadow: 0 0 0 3px #e4e7eb; */
    }

    header .headWxTriangle {
        position: absolute;

        /* box-shadow: 0 0 0 3px #e4e7eb; */
        top: -5px;
        left: 102px;
        display: block;
        width: 9px;
        height: 9px;
        background-color: white;
        border: 1px solid #b8b8b8;
        transform: rotate(45deg);
    }

    header .headWxBox {
        position: relative;
        width: 100%;
        height: 100%;
        background-color: white;
    }

    header .headWxBox > img {
        float: left;
        width: 120px;
        height: 120px;
        margin: 3px;
    }

    header .headAppWrap {
        /* display: none; */
        position: absolute;
        top: 35px;
        right: 0;
        z-index: 5;
        width: 126px;
        height: 126px;
        background-color: white;
        border: 1px solid #b8b8b8;
        border-radius: 1px;

        /* box-shadow: 0 0 0 3px #e4e7eb; */
    }

    header .headAppTriangle {
        position: absolute;

        /* box-shadow: 0 0 0 3px #e4e7eb; */
        top: -5px;
        left: 78px;
        display: block;
        width: 9px;
        height: 9px;
        background-color: white;
        border: 1px solid #b8b8b8;
        transform: rotate(45deg);
    }

    header .headAppBox {
        position: relative;
        width: 100%;
        height: 100%;
        background-color: white;
    }

    header .headAppBox > img {
        float: left;
        width: 120px;
        height: 120px;
        margin: 3px;
    }

    header .headCustomerServiceWrap {
      /* display: none; */
      position: absolute;
      top: 35px;
      right: 0;
      z-index: 4;
      width: 66px;
      padding: 10px;
      background-color: white;
      border: 1px solid #b8b8b8;
      border-radius: 1px;
    }

    header .headCustomerServiceBox {
      position: relative;
      width: 100%;
      background-color: white;
    }

    header .headCustomerServiceBox .headCustomerServiceUl {
      position: relative;
      width: 100%;
    }

    header .headCustomerServiceBox .headCustomerServiceUl > li {
      position: relative;
      box-sizing: border-box;
      float: left;
      width: 100%;
      height: 30px;
      padding: 5px 9px;
      margin-bottom: 5px;
    }

    header .headCustomerServiceBox .headCustomerServiceUl > li:last-child {
      margin-bottom: 0;
    }

    header .headCustomerServiceBox .headCustomerServiceUl > li > a {
      display: block;
      height: 100%;
      overflow: hidden;
      font-size: 12px;
      line-height: 20px;
      color: #4c4c4c;
      white-space: nowrap;
    }

    header .headCustomerServiceBox .headCustomerServiceUl > li:hover {
      background-color: #f5f5f5;
    }

    header .headCustomerServiceBox .headCustomerServiceUl > li > .exportCustomerServiceQQ {
      background-position-y: 0;
    }

    header .headCustomerServiceBox .headCustomerServiceUl > li > .importCustomerServiceQQ {
      background-position-y: -25px;
    }



    header .headLangWrap {
        /* display: none; */
        position: absolute;
        top: 35px;
        right: 0;
        z-index: 4;
        width: 190px;
        padding: 10px;
        background-color: white;
        border: 1px solid #b8b8b8;
        border-radius: 1px;
    }

    header .headLangBox {
        position: relative;
        width: 100%;
        background-color: white;
    }

    header .headLangBox .headLangUl {
        position: relative;
        width: 100%;
    }

    header .headLangBox .headLangUl > li {
        position: relative;
        box-sizing: border-box;
        float: left;
        width: 100%;
        height: 30px;
        padding: 5px 9px;
        margin-bottom: 5px;
    }

    header .headLangBox .headLangUl > li:last-child {
        margin-bottom: 0;
    }

    header .headLangBox .headLangUl > li > a {
        display: block;
        height: 100%;
        padding-left: 26px;
        overflow: hidden;
        font-size: 12px;
        line-height: 20px;
        color: #4c4c4c;
        white-space: nowrap;
        background-image: url('~@/assets/img/header/un_header_language_1807.png');
        background-repeat: no-repeat;
    }

    header .headLangBox .headLangUl > li:hover {
        background-color: #f5f5f5;
    }

    header .headLangBox .headLangUl > li > .langChineseZH {
        background-position-y: 0;
    }

    header .headLangBox .headLangUl > li > .langChineseHK {
        background-position-y: -25px;
    }

    header .headLangBox .headLangUl > li > .langEnglishUS {
        background-position-y: -300px;
    }

    header .headLangBox .headLangUl > li > .CNY {
        background-position-y: 0;
    }

    header .headLangBox .headLangUl > li > .USD {
        background-position-y: -300px;
    }

    header .headLangBox .headLangUl > li > .EUR {
        background-position-y: -420px;
    }

    header .headCurrencyWrap {
        position: absolute;
        top: 35px;
        right: 0;
        z-index: 4;
        width: 100px;
        padding: 10px;
        background-color: white;
        border: 1px solid #b8b8b8;
        border-radius: 1px;
    }

    header .headBot {
        position: relative;
        width: 100%;
        height: 120px;
        background-color: #f3f3f4;
    }

    header .headBotBox {
        position: relative;
        width: 1245px;
        height: 100%;
        margin: 0 auto;
    }

    header .headBotLeft {
        position: absolute;
        margin-top: 17px;

        /* width: 180px; */

        /* height: 83px; */
    }

    header .logoBox {
        position: relative;
        display: block;
        width: 100%;
        height: 100%;
        overflow: hidden;
        user-select: none;
    }

    header .headSjmLogo {
        position: relative;
        float: left;
        width: 77px;
        height: 77px;
        background-image: url("~@/assets/img/header/sjm_logo.png");
    }

    header .headLogoTit {
        position: absolute;
        top: 28px;
        left: 94px;
        font-size: 22px;

        /* font-family: '宋体'; */
        color: #595757;
    }

    header .headLogoTitTips {
        position: absolute;
        top: 71px;
        left: 94px;
        font-size: 14px;
        color: #9a9ea0;

        > span {
            display: inline-block;
            height: 25px;
            padding: 0 10px;
            line-height: 25px;
            color: white;

            &:first-child {
                padding-left: 20px;
            }

            &:last-child {
                padding-right: 20px;
                border-top-right-radius: 13px;
                border-bottom-right-radius: 13px;
            }
        }

        .blue {
            background-color: #29abe2;
        }

        .red {
            background-color: #e71a40;
        }

        .yellow {
            background-color: #f4b01c;
        }
    }

    header .headBotRight {
        position: relative;
        float: right;
        height: 66px;
        margin-top: 34px;
    }

    header .headProperty {
        position: relative;
        height: 100%;
    }

    header .headProperty > li {
        position: relative;
        float: right;
        height: 100%;
        padding: 0 30px;
        text-align: center;
        border-left: 1px solid rgba(89, 87, 87, 0.5);
    }

    header .headProperty > li:first-child {
        padding-right: 0;
    }

    header .headProperty > li:last-child {
        border: none;
    }

    header .headProperty > li > i.iconfont {
        position: relative;
        top: 4px;
        font-size: 38px;
        color: #29abe2;
    }

    header .headProperty > li > span {
        font-size: 12px;
        color: #717071;
    }

    header .headTopRight > #headTopNav > li.headUsername a {
        display: inline-block;

        /* max-width: 100px; */
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    header .headUsername,
    header .headSignOut,
    header .shoppingCart {
        /* display: none; */
    }
</style>
